import { createSelector } from 'reselect'

const selector = state => state.readyOrdersReducer

export const readyFilterSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const readyLoadMoreSelector = createSelector(
  [selector],
  ({ loadMore }) => loadMore
)

export const readyLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const readyErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const readyLoadsSelector = createSelector(
  [selector],
  ({ orders }) => orders
)

export const readyNoMoreSelector = createSelector(
  [selector],
  ({ noMore }) => noMore
)

export const readySelector = createSelector(
  [selector],
  ready => ready
)
